import React from 'react';
import { useTheme, useMediaQuery } from '@mui/material';

export default function VideoView(props)
{
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('md'));
    
    // Responsive height variables - you can tune these as needed
    const desktopHeight = 600;
    const mobileHeight = 300;

    if (props.videoURL == undefined) return <div></div>;
    
    const urlObj = new URL(props.videoURL);
    const params = new URLSearchParams(urlObj.search);
    const autoplay = props.autoplay ? '1' : '0';
    const controls = props.controls ? '1' : '0';
    const mute = props.mute ? '1' : '0';
    const loop = props.loop ? '1' : '0';
    const srcValue = "https://www.youtube.com/embed/" + params.get("v") + "?autoplay=" + autoplay + "&mute=" + mute + "&controls=" + controls + "&loop=" + loop;
    const height = isMobile ? mobileHeight : desktopHeight;

    return (
        <div>
            <iframe width="100%" height={height} style={{ border: "none" }}
                src={srcValue}>
            </iframe>
        </div>
    );
}

export function VideoDiagnosis(props)
{
    return null;
}
